import { render, staticRenderFns } from "./PayrollFinalizationNew.vue?vue&type=template&id=11389287"
import script from "./PayrollFinalizationNew.vue?vue&type=script&lang=js"
export * from "./PayrollFinalizationNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports